/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilenewplace2Inputs */

const en_profilenewplace2 = /** @type {(inputs: Profilenewplace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New place`)
};

const de_profilenewplace2 = /** @type {(inputs: Profilenewplace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Ort`)
};

/**
* | output |
* | --- |
* | "New place" |
*
* @param {Profilenewplace2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilenewplace2 = /** @type {((inputs?: Profilenewplace2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilenewplace2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilenewplace2(inputs)
	return de_profilenewplace2(inputs)
});
export { profilenewplace2 as "profileNewPlace" }